import { DICTIONARY_SYLLABLES } from "@-/com.npmjs.kensio__pinyinjs";
import onetime from "@-/com.npmjs.onetime";

/** PinyinJS's complete dictionary inventory, including rare forms; v represents ü. */
export const getPinyinSyllables = onetime((): readonly string[] =>
  Array.from(DICTIONARY_SYLLABLES, (syllable) => syllable.replaceAll("ü", "v")),
);
